module.exports = ".pic-small {\n  max-width: 128px;\n  max-height: 128px;\n  min-width: 64px;\n  min-height: 64px; }\n\n.breakWord {\n  word-break: break-all; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/devices/editScheduleEntryModal/editScheduleEntryModal.component.scss
// module id = ./src/app/views/devices/editScheduleEntryModal/editScheduleEntryModal.component.scss
// module chunks = main